import React, { useEffect } from 'react';
import { Nav } from './Nav';
import { Hero } from './Hero';
import { AppPreview } from './AppPreview';
import { AllInOneSection } from './AllInOneSection';
import { SplitBuySellSection } from './SplitBuySellSection';
import { CashOutGoalSection } from './CashOutGoalSection';
import { ComparisonSection } from './ComparisonSection';
import { CgtSection } from './CgtSection';
import { PricingSection } from './PricingSection';
import { FinalCTA } from './FinalCTA';
import { LandingFooter } from './LandingFooter';
import { LandingDisclaimer } from './LandingDisclaimer';

export function LandingPage() {
  // The landing page is always dark, regardless of the user's in-app theme.
  // We pin <html> to the dark class while this page is mounted, then restore.
  useEffect(() => {
    const html = document.documentElement;
    const wasLight = html.classList.contains('light');
    if (wasLight) {
      html.classList.remove('light');
      html.classList.add('dark');
    }
    const prevScrollBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'smooth';
    return () => {
      if (wasLight) {
        html.classList.remove('dark');
        html.classList.add('light');
      }
      html.style.scrollBehavior = prevScrollBehavior;
    };
  }, []);

  return (
    <div
      className="min-h-screen font-sans antialiased"
      style={{
        backgroundColor: '#0c0e12',
        color: '#f4f1ea',
        fontFamily:
          'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      }}
    >
      <Nav />
      <Hero />
      <AppPreview />
      <AllInOneSection />
      <SplitBuySellSection />
      <CashOutGoalSection />
      <ComparisonSection />
      <CgtSection />
      <PricingSection />
      <FinalCTA />
      <LandingFooter />
      <LandingDisclaimer />
    </div>
  );
}
